import createIcon from '../../createIcon';

/**
 * @component @name FiberSmartRecord
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAyMEMxMy40MTgzIDIwIDE3IDE2LjQxODMgMTcgMTJDMTcgNy41ODE3MiAxMy40MTgzIDQgOSA0QzQuNTgxNzIgNCAxIDcuNTgxNzIgMSAxMkMxIDE2LjQxODMgNC41ODE3MiAyMCA5IDIwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3IDQuMjZWNi4zNUMxOS4zMyA3LjE3IDIxIDkuMzkgMjEgMTJDMjEgMTQuNjEgMTkuMzMgMTYuODMgMTcgMTcuNjVWMTkuNzRDMjAuNDUgMTguODUgMjMgMTUuNzMgMjMgMTJDMjMgOC4yNyAyMC40NSA1LjE1IDE3IDQuMjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FiberSmartRecord = createIcon('FiberSmartRecord', [
  [
    'path',
    {
      d: 'M9 20C13.4183 20 17 16.4183 17 12C17 7.58172 13.4183 4 9 4C4.58172 4 1 7.58172 1 12C1 16.4183 4.58172 20 9 20Z',
      key: 'm8euw9',
    },
  ],
  [
    'path',
    {
      d: 'M17 4.26V6.35C19.33 7.17 21 9.39 21 12C21 14.61 19.33 16.83 17 17.65V19.74C20.45 18.85 23 15.73 23 12C23 8.27 20.45 5.15 17 4.26Z',
      key: '8g780z',
    },
  ],
]);

export default FiberSmartRecord;
